import { createFeatureSelector, createSelector } from '@ngrx/store';

import { dataProviderFeatureKey, State } from '../reducers/data-provider.reducer';

export const selectDataProviderFeature = createFeatureSelector<State>(dataProviderFeatureKey);

export const selectId = createSelector(selectDataProviderFeature, (state: State) => state.id);

export const selectIsAuthenticated = createSelector(selectDataProviderFeature, (state: State) =>
  state.isBlackKnight ? state.isAuthenticated : true
);

export const selectLoginFormValidationErrors = createSelector(
  selectDataProviderFeature,
  (state: State) => state.loginFormValidationErrors
);

export const selectDataProviderCredentials = createSelector(selectDataProviderFeature, (state: State) => ({
  password: state.password,
  username: state.username
}));

export const selectUsername = createSelector(selectDataProviderFeature, (state: State) => state.username);

export const selectIsDataTrace = createSelector(selectDataProviderFeature, (state: State) => state.isDataTrace);

export const selectIsBlackKnight = createSelector(selectDataProviderFeature, (state: State) => state.isBlackKnight);
